<template>
<div>
    <v-app-bar flat color="headerback" dark app fixed :shrink-on-scroll="!$vuetify.breakpoint.smAndDown" :prominent="!$vuetify.breakpoint.smAndDown" :height="($vuetify.breakpoint.smAndDown ? undefined: 100)">
        <v-toolbar-title @click.stop="home()">
            <v-img :max-width="($vuetify.breakpoint.smAndDown ? 200 : 235)" src="/img/logo.png"></v-img>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-app-bar-nav-icon @click.stop="drawerOpenClose()" v-on="on" v-show="Number(userInfo().id) > 0"></v-app-bar-nav-icon>
            </template>
            <span>Головне меню</span>
        </v-tooltip>
    </v-app-bar>

    <NavigationDrawerRight />
</div>
</template>

<script>
import NavigationDrawerRight from '@/components/NavigationDrawerRight.vue'
import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    components: {
        NavigationDrawerRight
    },
    data: () => ({
        navigationDrawerOpened: false,
        ...mapGetters(['userInfo']),
    }),
    props: {},
    methods: {
        ...mapActions(['getReferenceList', 'getUserInfo']),
        drawerOpenClose() {
            const refresh = 1
            this.getUserInfo(refresh)
                .then(d => this.getReferenceList())
                .catch(err => console.log(err))
            this.$store.commit('openCloseNavigationDrawerRight', !this.navigationDrawerOpened);
        },
        home () {
            if (this.$route.name != 'home') { 
                this.$router.push('/')
            }
        }
    },
    created() {},
    computed: {}
}
</script>
